import { Button, Checkbox, Input } from 'antd'
import { useState } from 'react'

const feedbackOptions = [
  '答非所问，没有准确理解问题的意图',
  '文本问答，答案不够理想',
  '图文问答，答案不够理想',
  '存在不安全或违法信息，模型无法作答',
]

const FeedBack = ({ submit }: any) => {
  const [checked, setChecked] = useState<any[]>([])
  const [input, setInput] = useState<string>('')

  return (
    <div className="flex flex-col gap-3 items-center">
      <Checkbox.Group
        options={feedbackOptions.map(i => ({ label: i, value: i }))}
        onChange={(checkedValue: any[]) => {
          setChecked(checkedValue)
        }}
      />
      <Input.TextArea
        autoSize={{
          minRows: 1,
          maxRows: 3,
        }}
        placeholder="您认为更优的答案是什么？"
        onChange={e => {
          setInput(e.target.value)
        }}
      />
      <Button
        type="primary"
        disabled={!checked.length && !input}
        onClick={() => {
          const contentList = input ? checked.concat(input) : checked
          submit(contentList.join('|'))
        }}
      >
        提交
      </Button>
    </div>
  )
}

export default FeedBack
